// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"36634c37","355":"07134081","427":"672d5b5c","460":"706a0001","492":"96462475","596":"57c6619c","609":"de19bf73","662":"c1097a2c","678":"df2ca237","695":"97f2b388","717":"5c6aea8b","735":"f818127d","810":"b0f129d4","824":"0a3d6c2c","896":"44fec0a0","985":"835406c0"}[chunkId] + ".chunk.js";
};